import { c as _c } from "react/compiler-runtime";
import { getOrgEntityStatusesOptions } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request';
import { useQuery } from '@tanstack/react-query';
const useCustomStatuses = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgEntityStatusesOptions({
      query: {
        includeDeactivated: false
      }
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  const {
    error
  } = query;
  let t1;
  if ($[1] !== error) {
    t1 = error ? getErrorMessage(error) : undefined;
    $[1] = error;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const errorMessage = t1;
  let t2;
  if ($[3] !== errorMessage || $[4] !== query) {
    t2 = {
      ...query,
      errorMessage
    };
    $[3] = errorMessage;
    $[4] = query;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default useCustomStatuses;